import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5dfc9c5d&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=5dfc9c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc9c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfc9c5d')) {
      api.createRecord('5dfc9c5d', component.options)
    } else {
      api.reload('5dfc9c5d', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5dfc9c5d&scoped=true&", function () {
      api.rerender('5dfc9c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/securityCheckMgr/accidentRegister/view.vue"
export default component.exports